import { sendSoundcloudEvent, sendSpotifyEvent } from '../../lib/analytics'
import { shareStatus } from '../../lib/share'
import { solution, song } from '../../lib/words'
import { CompletedRow } from './CompletedRow'
import { CurrentRow } from './CurrentRow'
import { EmptyRow } from './EmptyRow'

type Props = {
  guesses: string[]
  currentGuess: any
  isGameFinished: boolean
  isGameLost: boolean
  handleShare: () => void
  claimCard: () => void
  handleOpen: () => void
}

export const Grid = ({ guesses, currentGuess, isGameFinished, handleShare, isGameLost, claimCard, handleOpen }: Props) => {
  const empties =
    guesses.length < 6 ? Array.from(Array(6 - guesses.length)) : []

  return (
    <>
      {!isGameFinished ? <div className="pb-2">
        {guesses.map((guess, i) => (
          <CompletedRow key={i} guess={guess} />
        ))}
        {guesses.length < 7 && <CurrentRow guess={currentGuess} isGameFinished={isGameFinished} />}
        {empties.map((_, i) => (
          <EmptyRow key={i} />
        ))}
      </div> :
        <div className="answer pb-6 flex flex-col items-center justify-center mb-1">
          <div className="w-80 h-96 border-solid border-2 flex flex-col items-center justify-center mx-0.5 text-lg font-bold rounded border-violet-500">
            <div className="text-white font-bold mb-3 text-center">Song of the day is "{solution}"</div>
            <img className="object-cover h-40 w-40 mb-3 rounded-full" src={song.cover} />
            {song.is_soundcloud === "FALSE" && <a href={song.spotify} className="mb-3"><button className="rounded-lg py-1 px-5 bg-emerald-500 text-white font-bold" onClick={() => {
              claimCard()
              sendSpotifyEvent()
            }}>Play on Spotify</button></a>}
            {song.is_soundcloud === "TRUE" && <a href={song.soundcloud} className="mb-3"><button className="rounded-lg py-1 px-5 bg-orange-500	text-white font-bold" onClick={() => {
              claimCard()
              sendSoundcloudEvent()
            }}>Play on Soundcloud</button></a>}
            <button className="rounded-lg py-1 px-5 bg-violet-500 text-white font-bold" onClick={() => {
              handleShare()
              shareStatus(guesses, isGameLost)
            }}>Share your game</button>
          </div>
          <button className="mt-5 rounded-lg p-2 px-5 bg-violet-500 text-white font-bold" onClick={handleOpen}>Save current game stats</button>
        </div>
      }
    </>
  )
}
